export const iconFontAwesomeSocialPhotoFilm = (
	<i className="fa-solid fa-photo-film"></i>
);
